// extracted by mini-css-extract-plugin
module.exports = {"user-layout":"style_user-layout__d3KiV","user-layout__section":"style_user-layout__section__1RHhy","second-sidebar":"style_second-sidebar__FaAG4","logout":"style_logout__Sk6SL"};